// extracted by mini-css-extract-plugin
export var artConsulting = "art_consulting-module--artConsulting--oxtfi";
export var artPageContent = "art_consulting-module--artPageContent--2zjoo";
export var imageContent = "art_consulting-module--imageContent--AkiWz";
export var textContent = "art_consulting-module--textContent--Juq9T";
export var consultingText = "art_consulting-module--consultingText--Lf7JS";
export var consultingGallery = "art_consulting-module--consultingGallery--kH4tt";
export var galleryRow = "art_consulting-module--galleryRow--53AeT";